var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav__logo"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Dogemory")])],1),_c('div',{staticClass:"nav__new-game",on:{"click":_vm.setNewGame}},[_vm._v("New Game")])])}
var staticRenderFns = []

export { render, staticRenderFns }